/** Runtime wiring set by configure() and consumed by ScannerView. */

export type WorkerFactory = () => Worker;

let workerFactory: WorkerFactory | null | undefined;

/** Explicit factory from configure(); null disables the worker entirely. */
export function setWorkerFactory(factory: WorkerFactory | null): void {
  workerFactory = factory;
}

/**
 * Resolve the decode-worker factory: an explicit one wins; otherwise try the
 * sibling dist file (works for bundler consumers and native ESM). Returns
 * null when workers are unavailable — the scanner then decodes inline.
 */
export function resolveWorkerFactory(): WorkerFactory | null {
  if (workerFactory !== undefined) return workerFactory;
  if (typeof Worker === "undefined") return null;
  try {
    const url = new URL("./decode.worker.js", import.meta.url);
    return () => new Worker(url, { type: "module" });
  } catch {
    return null;
  }
}
